import { render } from "./com_educacion_ofertas.vue?vue&type=template&id=36b6eec2&scoped=true"
import script from "./com_educacion_ofertas.vue?vue&type=script&lang=js"
export * from "./com_educacion_ofertas.vue?vue&type=script&lang=js"

import "./com_educacion_ofertas.vue?vue&type=style&index=0&id=36b6eec2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b6eec2"]])

export default __exports__